import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { ProjelerEditComponent } from './projeler-edit.component';
import { ProjelerKartComponent } from './projeler-kart.component';
import { ProjelerKartSadeComponent } from './projeler-kart-sade.component';
import { ProjelerSayfaComponent } from './projeler-sayfa.component';

@DinamikBilesen({
  id: 'projeler',
  baslik: 'Projeler',
  aciklama: 'Proje oluştur ve takip et',
  ikon: 'project',
  kategori: 'uyar',
})
class Projeler {
  paylas_kutusu = ProjelerEditComponent;
  paylasilmis_kart = ProjelerKartComponent;
  paylasilmis_kart_sade = ProjelerKartSadeComponent;
  sayfa = ProjelerSayfaComponent;

  
  hesaplamalar = {
    pipeline: [
      { $match: { _uid: '{{kartId}}', silindi: { $ne: true } } },
      { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'icerikDetay' } },
      { $unwind: { path: '$icerikDetay', preserveNullAndEmptyArrays: false } },
      { $group: {
        _id: { $ifNull: ['$icerikDetay.ek.bilesen', '$icerikDetay.ek._secilenSetId'] },
        toplam: { $sum: 1 },
        tamamlanan: { $sum: { $cond: [{ $eq: ['$icerikDetay.ek.durum', 'tamamlandi'] }, 1, 0] } },
        devamEden: { $sum: { $cond: [{ $eq: ['$icerikDetay.ek.durum', 'devam-ediyor'] }, 1, 0] } }
      }}
    ],
    prepipe: [
      { $lookup: { from: 'hareketler', let: { pid: '$_id' }, pipeline: [
        { $match: { $expr: { $eq: ['$_uid', '$$pid'] }, silindi: { $ne: true } } },
        { $lookup: { from: 'hareketler', localField: 'veri.icerikler', foreignField: '_id', as: 'ic' } },
        { $unwind: { path: '$ic', preserveNullAndEmptyArrays: false } }
      ], as: '_alt' } },
      { $addFields: {
        '_hesap.toplamGorev': { $size: '$_alt' },
        '_hesap.tamamlananGorev': { $size: { $filter: { input: '$_alt', cond: { $eq: ['$$this.ic.ek.durum', 'tamamlandi'] } } } },
        '_hesap.notSayisi': { $size: { $filter: { input: '$_alt', cond: { $in: ['$$this.ic.ek.bilesen', ['not', 'yorum']] } } } }
      }},
      { $project: { _alt: 0 } }
    ]
  };
}
